import React from 'react';
import { Box, Text, Flex, VStack } from '@chakra-ui/react';

interface TooltipCardProps {
  propertyName: string;
  location: string;
  sopDeviation: string;
  dealSentiment: string;
  position?: { top: string | number; left: string | number };
  isVisible?: boolean;
  metrics?: { label: string; value: string }[];
}

const TooltipCard: React.FC<TooltipCardProps> = ({ 
  propertyName, 
  location, 
  sopDeviation, 
  dealSentiment,
  position = { top: "56px", left: "225px" },
  isVisible = false,
  metrics = []
}) => {
  if (!isVisible) return null;
  
  // Use metrics array if provided, otherwise fall back to hardcoded metrics
  const metricsToDisplay = metrics.length > 0 ? metrics : [
    { label: "SOP Deviation", value: sopDeviation },
    { label: "Deal Sentiment", value: dealSentiment }
  ];
  
  return (
    <Box
      position="absolute"
      display="flex"
      flexDirection="column"
      gap="8px"
      p="8px"
      bg="white"
      borderRadius="lg"
      border="1px"
      borderColor="indigo.400"
      width="181px"
      top={position.top}
      left={position.left}
      boxShadow="md"
      zIndex={10}
    >
      <VStack align="flex-start" spacing={1} mb={2}>
        <Text fontWeight="medium" fontSize="sm" color="gray.800">
          {propertyName}
        </Text>
        <Text fontSize="xs" color="gray.500">
          {location}
        </Text>
      </VStack>

      {metricsToDisplay.map((metric, index) => (
        <Box key={index} px={2} py={1} bg="gray.200" borderRadius="md">
          <Flex justify="space-between" align="center">
            <Text fontSize="xl" fontWeight="medium" color="gray.800">{metric.value}</Text>
            <Text fontSize="xs" color="gray.600">
              {metric.label}
            </Text>
          </Flex>
        </Box>
      ))}
    </Box>
  );
};

export default TooltipCard; 